<template>
  <div class="study_details">
    <MainHeader />
    <SideMenu :studyData="studyData" />
    <div class="content has-header">
      <div class="export-btn-container">
        <button :class="exportPdfClicked ? 'btn disabled' : isComponentisFullyLoaded == false ? 'btn disabled' : 'btn'" type="button" @click="generateReport" :disabled="exportPdfClicked || isComponentisFullyLoaded == false">
          <img class="download-icon" src="static/img/Download-icon.svg" />
          <span class="text">Export to PDF</span>
        </button>
      </div>
      <div class="row details_bg" v-if="studyDetails">
        <div ref="html2Pdf" id="pdf-container">
          <section slot="pdf-content">
            <!-- PDF Content Here -->
            <StudyDetailsPDF
              :countryList="countryList"
              :studyData="studyData"
              :studyDetails="studyDetails"
              :isMultipleConsent="isMultipleConsent"
              :activityDetails="activityDetailsList"
              :therapeuticAreas="therapeuticAreas"
              :surveyDetails="surveyDetails"
              :eprosDetails="eprosDetails"
              :visitDetails="visitDetails"
              :thRecordingAllowedInCountries="thRecordingAllowedInCountries"
              :isTelehealthRecordingFeature="isTelehealthRecordingFeature"
              :agreement="agreement"
              :eligibility="eligibility"
              :registrationformWebfields="registrationformWebfields"
              :registrationSite="registrationSite"
              :registrationSiteFact="registrationSiteFact"
              :registrationFormFlag="registrationFormFlag"
              :exportPdfClicked="exportPdfClicked"
            />
          </section>
        </div>
        <div class="container p-20 container-content">
          <!-- Display study type Start-->
          <div class="pb-12">
            <div class="card br-2">
              <div class="p-10 pb-20">
                <h6 class="fw-bold">GENERIC STUDY SETTINGS</h6>
                <div class="pt-5 row">
                  <div class="col-lg-3 col-md-7 p-0">Study type:</div>
                  <div class="col-lg-3 col-md-5">
                    {{ studyData.subType ? studyData.subType : "Digital Invitation" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Display study type End-->

          <CountryLanguageDetails class="pb-12" :countryLanguageDetails="countryList" v-if="studyData.linkedCountryLanguages" />
          <BrandingDetails class="pb-12" :brandingDetails="studyDetails.studyBrandingDetails" v-if="studyDetails.studyBrandingDetails" />
          <StudyMilestones class="pb-12" :studyMilestones="studyDetails.milestonesList" v-if="studyDetails.milestonesList && studyDetails.milestonesList.length > 0" :studyData="studyData" />
          <ParticipantConfiguration
            :options="{
              isParticipantIdEditable: studyDetails.isParticipantIdEditable,
              isParticipantIdRequired: studyDetails.isParticipantIdRequired,
              participantIdFormatConfigured: studyDetails.participantIdFormatConfigured
            }"
            :allowDuplicatePid="studyDetails.allowDuplicatePid"
          ></ParticipantConfiguration>
          <ParticipantTriggerDayZeroDetail v-if="studyDetails.isManualStudyStart"></ParticipantTriggerDayZeroDetail>
          <RegistrationDetails class="pb-12" :studyData="studyData" :registrationDetails="studyDetails.registrationDetails.participantRegistrationConfigDetails" v-if="studyData && studyDetails.registrationDetails" />
          <OnboardingDetails class="pb-12" :onboardingDetails="studyDetails.welcomeScreenDetails" v-if="studyDetails.welcomeScreenDetails" />
          <EligibilityDetails class="pb-12" :eligibilityDetails="studyDetails.eligibilityQuestionsDetails" v-if="studyDetails.eligibilityQuestionsDetails && studyDetails.eligibilityQuestionsDetails.length > 0" />
          <eConsentDetails class="pb-12" :eConsentDetails="studyDetails.eConsentsDetails" :isMultipleConsent="isMultipleConsent" v-if="!isMultipleConsent && studyDetails.eConsentsDetails" />
          <eConsentDetails class="pb-12" :eConsentDetails="studyDetails.eConsentsDetails" :isMultipleConsent="isMultipleConsent" v-if="isMultipleConsent && studyDetails.eConsentsDetails" />
          <SurveyDetails class="pb-12" :surveyDetails="surveyDetails" :studyData="studyData" v-if="studyDetails.surveysSelected && surveyDetails && !studyData.activityAllowed" />
          <ePRODetails class="pb-12" :eprosDetails="eprosDetails" :studyData="studyData" v-if="studyDetails.eprosSelected && eprosDetails && !studyData.activityAllowed" />
          <eDRODetails class="pb-12" :edroDetails="studyDetails.edroDetails" :studyData="studyData" v-if="studyDetails.edroDetails" />
          <ActivitiesDetails class="pb-12" :activityDetails="activityDetails" :studyData="studyData" :therapeuticAreas="therapeuticAreas" :participantRegistrationConfigDetails="registrationSite && registrationSite.participantRegistrationConfigDetails" v-if="activityDetails && studyData.activityAllowed" />
          <MobileHealthDataAccess class="pb-12" :mobileHealthDetails="studyDetails.healthDataAccessDetails" v-if="studyDetails.healthDataAccessDetails && studyDetails.healthDataAccessDetails.length > 0" />
          <DashboardDetails class="pb-12" :dashboardDetails="studyDetails.dashboardDetails" v-if="studyDetails.dashboardDetails" />
          <NotificationsDetails class="pb-12" :studyData="studyData" :notificationDetails="studyDetails.customNotificationDetails" v-if="studyDetails.customNotificationDetails && studyDetails.customNotificationDetails.length > 0" />
          <MedicalDevices class="pb-12" :medicalDeviceDetails="studyDetails.medicalDevicesWearablesDetails" v-if="studyDetails.medicalDevicesWearablesDetails" />
          <EngagementContent class="pb-12" :engagementContentDetails="studyDetails.learnMoreDetails" v-if="studyDetails.learnMoreDetails" />
          <TeleHealthDetails class="pb-12" :visits="visitDetails" :studyData="studyData" :studyDetails="studyDetails" :thRecordingAllowedInCountries="thRecordingAllowedInCountries" :isTelehealthRecordingFeature="isTelehealthRecordingFeature" v-if="studyData.telehealthIntegration && (studyData.ios || studyData.android)" />
          <ParticipantWebDetails class="pb-12" :agreement="agreement" :eligibility="eligibility" :registrationformWebfields="registrationformWebfields" :registrationSite="registrationSite" :registrationSiteFact="registrationSiteFact" :registrationFormFlag="registrationFormFlag" />
          <div class="card p-10" v-if="studyDetails.activityOrderInfos && studyDetails.activityOrderInfos.length > 0">
            <h6 class="fw-bold">ACTIVITY ORDER</h6>
            <div>
              <ul>
                <li v-for="(activity, index) in studyDetails.activityOrderInfos" :key="index">
                  {{ activity.activityName }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sortBy from "lodash/sortBy";
import _ from "lodash";
import MainHeader from "../components/common/main-header";
import SideMenu from "../components/common/side-menu";
import CountryLanguageDetails from "../components/study-details/country-language-details";
import BrandingDetails from "../components/study-details/branding-details";
import StudyMilestones from "../components/study-details/study-milestones";
import RegistrationDetails from "../components/study-details/registration-details";
import OnboardingDetails from "../components/study-details/onboarding-details";
import EligibilityDetails from "../components/study-details/eligibility-details";
import eConsentDetails from "../components/study-details/econsent-details";
import SurveyDetails from "../components/study-details/surveys-details";
import ePRODetails from "../components/study-details/epros-details";
import eDRODetails from "../components/study-details/edros-details";
import ActivitiesDetails from "../components/study-details/activities-details";
import MobileHealthDataAccess from "../components/study-details/mobileHealthDataAccess";
import DashboardDetails from "../components/study-details/dashboards-details";
import NotificationsDetails from "../components/study-details/notifications-details";
import MedicalDevices from "../components/study-details/medicaldevices-wearables";
import EngagementContent from "../components/study-details/engagement-content";
import TeleHealthDetails from "../components/study-details/teleHealth-details";
import ParticipantWebDetails from "../components/study-details/participant-web-details";
import ParticipantTriggerDayZeroDetail from "../components/study-details/participant-day-zero-details";
import ParticipantConfiguration from "../components/study-details/participant-configuration";
import QlVideoUploadService from "@/services/ql-video-upload";
import html2pdf from "html2pdf.js";
import StudyDetailsPDF from "../../src/pages/study-details-pdf";
/* IMPORTANT
Any changes made in the component inside the study-details folder should also be made in 
the component inside the study-details-pdf folder so that it gets reflected when we generate 
the PDF by clicking the Export to PDF button.
 */
export default {
  name: "study-details",
  data() {
    return {
      studyId: "",
      studyData: {},
      agreement: {},
      eligibility: {},
      registrationformWebfields: {},
      registrationSite: {},
      registrationSiteFact: [],
      registrationFormFlag: {},
      studyDetails: {},
      surveyDetails: [],
      thRecordingAllowedInCountries: [],
      activityDetails: [],
      activityDetailsList: [],
      eprosDetails: [],
      visitDetails: [],
      isMultipleConsent: true,
      isTelehealthRecordingFeature: false,
      qlVideoUpload: null,
      countryList: [],
      studyLanguage: [],
      linkedLC: {},
      therapeuticAreas: [],
      exportPdfClicked: false,
      isComponentisFullyLoaded: false
    };
  },
  methods: {
    isMultipleConsentEnabled() {
      const that = this;
      that.toggleFeatures = that.$store.getters.getStudyToggledFeatures ? that.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      const isEconsent = that.toggleFeatures.filter(x => x.featureKey == "ECONSENT");
      if ((isEconsent == null || isEconsent == undefined || isEconsent == "") && isEconsent.length == 0) {
        that.isMultipleConsent = true;
      } else {
        that.isMultipleConsent = false;
      }
      this.toggleStudyDetails();
    },
    toggleStudyDetails() {
      const that = this;
      if (that.isMultipleConsent === false) {
        this.getStudyDetails();
      } else {
        this.getStudyDetailsV2();
      }
    },
    getLinkedLanguages(countryId) {
      let languageNameList = [];
      const linkedLanguageIds = this.linkedLC[countryId];
      for (let i = 0; i < this.studyLanguage.length; i++) {
        for (let j = 0; j < linkedLanguageIds.length; j++) {
          if (!!this.studyLanguage[i] && this.studyLanguage[i].language_id === linkedLanguageIds[j]) {
            languageNameList.push(this.studyLanguage[i].display_name);
          }
        }
      }
      const languageUS = "English";
      languageNameList = languageNameList.sort();
      if (languageNameList.includes(languageUS)) {
        languageNameList = languageNameList.filter(item => item !== languageUS);
        languageNameList.unshift(languageUS);
      }
      return languageNameList.join(", ");
    },
    getStudyData() {
      this.studyData = JSON.parse(window.localStorage.getItem("studyDetailsData"));
      this.countryList = this.studyData.countryList ? this.studyData.countryList : [];
      this.studyLanguage = this.studyData.studyLanguage ? this.studyData.studyLanguage : [];
      this.linkedLC = this.studyData.linkedCountryLanguages ? this.studyData.linkedCountryLanguages : [];

      for (const countryId in this.linkedLC) {
        for (let i = 0; i < this.countryList.length; i++) {
          if (!!this.countryList[i] && this.countryList[i].countryId === countryId) {
            const linkedLanguageNames = this.getLinkedLanguages(countryId);
            this.countryList[i].linkedLanguageNames = linkedLanguageNames;
          }
        }
      }
      this.countryList = this.countryList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
    },
    getParticipantWeb() {
      let sitesFact = [];
      let webAddSites = [];
      this.$api
        .getParticipantWebAddSites(this.studyId)
        .then(response => {
          if (response) {
            webAddSites = response.body.data;
            this.$api
              .getSitesFact(this.studyId)
              .then(response => {
                if (response) {
                  sitesFact = response.body;
                  if (webAddSites) {
                    webAddSites.forEach(e => {
                      const temp = sitesFact.find(element => element.id === e.site_id);
                      if (temp) {
                        this.registrationSiteFact.push(temp);
                      }
                    });
                  }
                }
              })
              .catch(err => {
                throw err;
              });
          }
        })
        .catch(err => {
          throw err;
        });
      this.$api
        .getParticipantWebAgreement(this.studyId)
        .then(response => {
          if (response.data.data) {
            this.agreement = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });
      this.$api
        .getParticipantWebEligibility(this.studyId)
        .then(response => {
          if (response.data.data) {
            this.eligibility = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });
      this.$api
        .getParticipantWebRegistration(this.studyId)
        .then(response => {
          if (response) {
            this.registrationFormFlag = response.body;
          }
        })
        .catch(err => {
          throw err;
        });
      this.$api
        .getParticipantWebRegistrationForm(this.studyId)
        .then(response => {
          if (response.data.data) {
            this.registrationformWebfields = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });

      this.$api
        .getRegistrationFact(this.studyId)
        .then(response => {
          if (response) {
            this.registrationSite = response.body;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    getStudyDetails() {
      this.$api.getStudyDetailsFact(this.studyId).then(response => {
        let order = false;
        this.studyDetails = response.body;

        //Extract the telehealth visits from the Study Details
        this.getVisitDetails();

        if (response.body.activityOrderInfos) {
          response.body.activityOrderInfos.forEach(item => {
            if (item.displayOrder === null) {
              order = true;
            }
          });
          if (order === true) {
            this.studyDetails.activityOrderInfos = sortBy(response.body.activityOrderInfos, "sequence");
          } else {
            this.studyDetails.activityOrderInfos = sortBy(response.body.activityOrderInfos, "displayOrder");
          }
        }
        if (this.studyDetails.surveysSelected) {
          this.getSurveyDetails();
        }
        if (this.studyDetails.eprosSelected) {
          this.geteprosDetails();
        }
      });
    },
    getStudyDetailsV2() {
      this.$api.getStudyDetailsFactV2(this.studyId).then(response => {
        let order = false;
        this.studyDetails = response.body;
        //Extract the telehealth visits from the Study Details
        this.getVisitDetails();

        if (response.body.activityOrderInfos) {
          response.body.activityOrderInfos.forEach(item => {
            if (item.displayOrder === null) {
              order = true;
            }
          });
          if (order === true) {
            this.studyDetails.activityOrderInfos = sortBy(response.body.activityOrderInfos, "sequence");
          } else {
            this.studyDetails.activityOrderInfos = sortBy(response.body.activityOrderInfos, "displayOrder");
          }
        }
        if (this.studyDetails.surveysSelected) {
          this.getSurveyDetails();
        }
        if (this.studyDetails.eprosSelected) {
          this.geteprosDetails();
        }

        if (this.studyDetails.eConsentsDetails.consentConfigurationSort && this.studyDetails.eConsentsDetails.consentConfigurationSort.length > 0) {
          _.map(this.studyDetails.eConsentsDetails.consentConfigurationSort, consent => {
            if (consent.listOfDisclaimer && consent.listOfDisclaimer.length > 0) {
              consent.listOfDisclaimer = _.filter(consent.listOfDisclaimer, "status");
            }
          });
        }
        let isDatavantFeatureEnabled =  this.toggleFeatures.find(feature => feature.featureKey === "Datavant");
        let isDatavantFeatureEnabledInStudy =  this.toggleFeatures.find(feature => feature.featureKey === "DatavantTokenization");
        if (
          isDatavantFeatureEnabled &&
          isDatavantFeatureEnabled.enabled &&
          isDatavantFeatureEnabledInStudy &&
          isDatavantFeatureEnabledInStudy.enabled &&
          this.studyDetails.datavantConsent &&
          this.studyDetails.datavantConsent.datavantConsentData &&
          this.studyDetails.datavantConsent.datavantConsentMeta         
        ) 
          {           
            this.studyDetails.datavantConsent.datavantConsentData[0].consentId = this.studyDetails.datavantConsent.datavantConsentMeta[0].consentId,
            this.studyDetails.datavantConsent.datavantConsentData[0].consentName = this.studyDetails.datavantConsent.datavantConsentMeta[0].consentName
          _.map(
            this.studyDetails.datavantConsent.datavantConsentData,                 
            consent => {
              if (
                consent.listOfDisclaimer &&
                consent.listOfDisclaimer.length > 0
              ) {
                consent.listOfDisclaimer = _.filter(
                  consent.listOfDisclaimer,
                  "status"
                );
              }
            }
          );
          this.studyDetails.eConsentsDetails.consentConfigurationSort.push( this.studyDetails.datavantConsent.datavantConsentData[0]);
          }       
        this.getNewS3VideoUrls( this.studyDetails );
      });
    },
    getSurveyDetails() {
      this.$api.getStudySurveyDetailsFact(this.studyId).then(response => {
        this.surveyDetails = sortBy(response.body, "sequence");
      });
    },
    geteprosDetails() {
      this.$api.getStudyeprosDetailsFact(this.studyId).then(response => {
        this.eprosDetails = response.body;
      });
    },
    filterTelehealthSchedulerForDisplay() {
      this.visitDetails.forEach(visit => {
        if (visit.type == "custom") {
          visit.duration.forEach(dur => {
            Object.keys(dur).forEach(key => {
              dur[key] -= this.studyData.screeningDuration;
            });
          });
        }

        if (visit.type == "milestone") {
          for (let i = 0; i < visit.milestones.length; i++) {
            visit.milestones[i] -= this.studyData.screeningDuration;
          }
        }
      });
    },
    getVisitDetails() {
      if (this.studyDetails.telehealthVisits && this.studyDetails.telehealthVisits.length > 0) {
        this.visitDetails = this.studyDetails.telehealthVisits;

        if (this.studyData.screeningMilestoneAllowed) {
          this.filterTelehealthSchedulerForDisplay();
        }
      }
    },
    getCountrySpecificStudyFeatures() {
      this.$api.getCountrySpecificStudyFeatures(this.studyId).then(
        response => {
          const countrySpecificStudyFeatures = response.body;
          const THEnabledCountries = _.filter(countrySpecificStudyFeatures, ["isTelehealthEnabled", true]);
          if (THEnabledCountries.length > 0) {
            this.isTelehealthRecordingFeature = THEnabledCountries[0].isTelehealthRecordingFeature;
          }
          if (
            _.filter(countrySpecificStudyFeatures, {
              isTelehealthRecordingFeature: false,
              isTelehealthEnabled: true
            }).length == 0
          ) {
            this.thRecordingAllowedInCountries = [];
          } else {
            this.thRecordingAllowedInCountries = _.filter(countrySpecificStudyFeatures, ["isTelehealthRecordingFeature", true]);
          }
        },
        error => {
          this.$toastr.error(error.body ? error.body.message : "Error while getting country specific telehealth status");
        }
      );
    },
    getNewS3VideoUrls(studyDetails) {
      if (studyDetails.welcomeScreenDetails && studyDetails.welcomeScreenDetails.screens && studyDetails.welcomeScreenDetails.screens.length) {
        this.qlVideoUpload.moduleName = "onboarding";
        studyDetails.welcomeScreenDetails.screens = this.qlVideoUpload.removeScriptAndStylesTexts(studyDetails.welcomeScreenDetails.screens, "content");
        this.qlVideoUpload.replaceSignedVideoS3Url(studyDetails.welcomeScreenDetails.screens, "content", studyDetails.welcomeScreenDetails.participantVideos);
      }
      if (studyDetails.learnMoreDetails && studyDetails.learnMoreDetails.sections && studyDetails.learnMoreDetails.sections.length) {
        this.qlVideoUpload.moduleName = "learnmore";
        studyDetails.learnMoreDetails.sections = this.qlVideoUpload.removeScriptAndStylesTexts(studyDetails.learnMoreDetails.sections, "sectionHtmlDetails");
        this.qlVideoUpload.replaceSignedVideoS3Url(studyDetails.learnMoreDetails.sections, "sectionHtmlDetails", studyDetails.learnMoreDetails.participantVideos);
      }
    },
    async getActivityDetails() {
      const participantFacingActivities = await this.getParticipantFacingActivities();
      const siteFacingActivities = await this.getSiteFacingActivities();
      this.mergeActivities(participantFacingActivities, siteFacingActivities);
    },
    getParticipantFacingActivities() {
      return this.$api.getStudyActivityDetailsFact(this.studyId).then(response => {
        return response.body;
      });
    },
    getSiteFacingActivities() {
      return this.$api.getSideFacingActivityDetailsFact(this.studyId).then(response => {
        return response.body;
      });
    },
    mergeActivities(participantFacingActivities, siteFacingActivities) {
      siteFacingActivities.forEach(item => {
        item.isSiteFacing = true;
      });
      const allActivities = [...participantFacingActivities, ...siteFacingActivities];
      this.activityDetails = _.sortBy(allActivities, "title");
      this.activityDetailsList = _.cloneDeep(this.activityDetails);
    },
    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          this.therapeuticAreas = response.body.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    async generateReport() {
      this.exportPdfClicked = true;
      this.$store.commit("SHOW_LOADER", true);
      setTimeout(() => {
        this.callGenerateReport();
      }, 10000);
    },
    async generateLargerPdfs(opt, clonedElement) {
      clonedElement.id = "pdf-container-1";
      clonedElement.style.display = "block";
      clonedElement.querySelectorAll(".second-page").forEach(el => {
        el.style.display = "none";
      });
      const clonedElement2 = clonedElement.cloneNode(true);
      window.document.getElementById("pdf-container").parentNode.appendChild(clonedElement2);
      clonedElement2.querySelectorAll(".second-page").forEach(el => {
        el.style.display = "block";
      });
      clonedElement2.querySelectorAll(".pdf-item").forEach(el => (el.style.display = "none"));
      clonedElement2.querySelectorAll(".details.pdf-item.second-page").forEach(el => (el.style.display = "block"));
      clonedElement2.querySelector(".details.pdf-item.activity-details-item").style.display = "block";
      clonedElement2
        .querySelector(".details.pdf-item.activity-details-item")
        .querySelector(".activity-container")
        .childNodes.forEach(el => {
          if (!el.classList.contains("second-page")) {
            el.style.display = "none";
          }
        });
      const doc = html2pdf()
        .set(opt)
        .from(clonedElement)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          pdf.addPage();
        })
        .from(clonedElement2)
        .toContainer()
        .toCanvas()
        .toPdf();
      clonedElement2.remove();
      clonedElement.remove();
      return doc.save();
    },
    async callGenerateReport() {
      this.$toastr.success("Your study configuration PDF file is being generated. This may take a few moments.");
      const element = window.document.getElementById("pdf-container");
      const clonedElement = element.cloneNode(true);
      try {
        element.style.display = "block";
        const originalHeight = element.clientHeight;
        const originalWidth = element.clientWidth;
        element.style.display = "none";
        element.parentNode.appendChild(clonedElement);
        clonedElement.style.display = "block";

        const opt = {
          margin: [15, 15],
          filename: "Study-details.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: window.devicePixelRatio,
            letterRendering: true
          },
          jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
          pagebreak: { mode: ["avoid-all", "css", "legacy"] }
        };
        /**
         * The browser canvas element have a limitation for max 32700 pixels in height so the total
         * page height is more than that we have to split the content manually and generate pdf pages and then merge them
         * together using underlying jsPdf library and genearte the single pdf file.
         */
        if (originalHeight < 30000 && originalHeight * originalWidth < 268435000) {
          await html2pdf()
            .set(opt)
            .from(clonedElement)
            .save();
        } else {
          await this.generateLargerPdfs(opt, clonedElement);
        }
        this.$store.commit("SHOW_LOADER", false);
      } catch (e) {
        clonedElement.remove();
        this.$store.commit("SHOW_LOADER", false);
      } finally {
        this.exportPdfClicked = false;
        clonedElement.remove();
        this.$store.commit("SHOW_LOADER", false);
      }
    },
    hasDownloaded() {
      this.exportPdfClicked = false;
    }
  },
  components: {
    MainHeader,
    SideMenu,
    CountryLanguageDetails,
    BrandingDetails,
    StudyMilestones,
    RegistrationDetails,
    OnboardingDetails,
    EligibilityDetails,
    eConsentDetails,
    SurveyDetails,
    ePRODetails,
    eDRODetails,
    ActivitiesDetails,
    MobileHealthDataAccess,
    DashboardDetails,
    NotificationsDetails,
    MedicalDevices,
    EngagementContent,
    TeleHealthDetails,
    ParticipantWebDetails,
    ParticipantTriggerDayZeroDetail,
    ParticipantConfiguration,
    StudyDetailsPDF
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService("onboarding", this.$route.params.studyId, localStorage.getItem("clientId"));
    this.studyId = this.$route.params.studyId;
    this.getStudyData();
    this.getTherapeuticAreas();
    this.getActivityDetails();
    setTimeout(() => {
      this.getParticipantWeb();
    }, 1000);
    this.isMultipleConsentEnabled();
    this.getCountrySpecificStudyFeatures();
    setTimeout(() => {
      this.isComponentisFullyLoaded = true;
    }, 6000);
  }
};
</script>

<style scoped lang="scss">
.study_details {
  display: flex;
  background-color: #f5f8fa;
}
.container-content {
  max-width: 100%;
}
.content {
  width: 100%;
  padding: 20px;
}
.details_bg {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.export-btn-container {
  text-align: right;
  margin-bottom: 24px;
  .btn {
    background-color: #fff;
    color: #4c8ce4;
    font-size: 14px;
    border: solid 1px #dbe2ed;
    border-radius: 4px;
  }
  .download-icon {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }
}
#pdf-container {
  display: none;
}
</style>
<style>
.html2pdf {
  display: none;
}
.html2pdf.in-pdf {
  display: block;
}
</style>
